// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../ui/styles/tavern-components.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header block */
.resource-events-page__header {
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-4);
  border-bottom: 2px solid var(--color-wood-600);
}

.resource-events-page__back {
  background: none;
  border: none;
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-fire-400);
  cursor: pointer;
  padding: 0;
  margin-bottom: var(--space-3);
  transition: color var(--transition-fast);
  display: inline-block;
}

.resource-events-page__back:hover {
  color: var(--color-fire-500);
}

.resource-events-page__resource-name {
  font-family: var(--font-heading);
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
  line-height: var(--line-height-h1);
  margin: 0 0 var(--space-2);
}

.resource-events-page__date {
  font-family: var(--font-body);
  font-size: var(--font-size-body-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-parchment-200);
  line-height: var(--line-height-body-lg);
}

/* Create button */
.resource-events-page__create-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  margin-bottom: var(--space-4);
  background: var(--color-fire-600);
  border: 2px solid var(--color-fire-700);
  border-radius: var(--radius-md);
  color: var(--color-parchment-100);
  font-family: var(--font-heading);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: var(--shadow-button);
}

.resource-events-page__create-btn:hover {
  background: var(--color-fire-500);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.resource-events-page__create-btn:active {
  transform: translateY(0);
}

/* Content */
.resource-events-page__content {
  min-height: 200px;
}

.resource-events-page__list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

/* Empty state on dark background */
.resource-events-page__content .tavern-empty-state-title {
  color: var(--color-parchment-200);
}

.resource-events-page__content .tavern-empty-state-description {
  color: var(--color-parchment-300);
}

@media (max-width: 425px) {
  .resource-events-page__resource-name {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
  }

  .resource-events-page__date {
    font-size: var(--font-size-body);
  }

  .resource-events-page__create-btn {
    padding: var(--space-2) var(--space-3);
    font-size: var(--font-size-body-sm);
  }
}

@media (min-width: 768px) {
  .resource-events-page__list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
}

@media (min-width: 1024px) {
  .resource-events-page__list {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FloorPlan/ResourceEventsPage.css"],"names":[],"mappings":"AAGA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,wCAAwC;EACxC,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,wCAAwC;EACxC,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;EAC7B,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sCAAsC;IACtC,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["@import '../_base.css';\n@import '../../ui/styles/tavern-components.css';\n\n/* Header block */\n.resource-events-page__header {\n  margin-bottom: var(--space-4);\n  padding-bottom: var(--space-4);\n  border-bottom: 2px solid var(--color-wood-600);\n}\n\n.resource-events-page__back {\n  background: none;\n  border: none;\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-fire-400);\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: var(--space-3);\n  transition: color var(--transition-fast);\n  display: inline-block;\n}\n\n.resource-events-page__back:hover {\n  color: var(--color-fire-500);\n}\n\n.resource-events-page__resource-name {\n  font-family: var(--font-heading);\n  font-size: var(--font-size-h1);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n  line-height: var(--line-height-h1);\n  margin: 0 0 var(--space-2);\n}\n\n.resource-events-page__date {\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-parchment-200);\n  line-height: var(--line-height-body-lg);\n}\n\n/* Create button */\n.resource-events-page__create-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-4);\n  margin-bottom: var(--space-4);\n  background: var(--color-fire-600);\n  border: 2px solid var(--color-fire-700);\n  border-radius: var(--radius-md);\n  color: var(--color-parchment-100);\n  font-family: var(--font-heading);\n  font-size: var(--font-size-body);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: var(--shadow-button);\n}\n\n.resource-events-page__create-btn:hover {\n  background: var(--color-fire-500);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.resource-events-page__create-btn:active {\n  transform: translateY(0);\n}\n\n/* Content */\n.resource-events-page__content {\n  min-height: 200px;\n}\n\n.resource-events-page__list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n/* Empty state on dark background */\n.resource-events-page__content .tavern-empty-state-title {\n  color: var(--color-parchment-200);\n}\n\n.resource-events-page__content .tavern-empty-state-description {\n  color: var(--color-parchment-300);\n}\n\n@media (max-width: 425px) {\n  .resource-events-page__resource-name {\n    font-size: var(--font-size-h2);\n    line-height: var(--line-height-h2);\n  }\n\n  .resource-events-page__date {\n    font-size: var(--font-size-body);\n  }\n\n  .resource-events-page__create-btn {\n    padding: var(--space-2) var(--space-3);\n    font-size: var(--font-size-body-sm);\n  }\n}\n\n@media (min-width: 768px) {\n  .resource-events-page__list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    align-items: start;\n  }\n}\n\n@media (min-width: 1024px) {\n  .resource-events-page__list {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
